export default {
    ordersLayout: {
        back: "Voltar",
        emptyOrders: "Ainda não tem encomendas.",
        loading: "A carregar",
        storeLabel: "Loja",
        totalLabel: "Total",
        storeAddressPending: "Morada disponível em breve",
        productNameFallback: "Produto",
        ecListTitle: "As suas encomendas",
        ecStatusInStore: "Estado: compra em loja",
        ecOrderNumber: "Número da encomenda: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} artigo: total {{amount}}",
        ecCountTotalOther: "{{count}} artigos: total {{amount}}",
        ecViewOrder: "Ver encomenda >",
        ecViewOrderA11y: "Ver encomenda {{order_number}}",
        ecBackToOrders: "Voltar às suas encomendas",
        ecInStoreDate: "Compra em loja – {{date}}",
        ecProductsOne: "Produto",
        ecProductsOther: "Produtos",
        ecSku: "Ref. {{sku}}",
        ecQty: "Quantidade: {{qty}}",
        ecWarrantyExpired: "Fora da garantia",
        ecWarrantyActive: "Em garantia",
        ecSubtotalOne: "Subtotal – {{count}} artigo",
        ecSubtotalOther: "Subtotal – {{count}} artigos",
    }
}



// WEBPACK FOOTER //
// ./src/locales/pt/index.js